// #######################################
// <---------- Branch actions ----------->
// #######################################
export const BRANCHES = 'BRANCHES'
export const DELETE_BRANCH = 'DELETE_BRANCH'
export const ADD_BRANCH = 'ADD_BRANCH'
export const EDIT_BRANCH = 'EDIT_BRANCH'

export const getBranches = (payload) => ({
  type: BRANCHES,
  payload
})

export const addBranch = (payload) => ({
  type: ADD_BRANCH,
  payload
})

export const editBranch = (payload) => ({
  type: EDIT_BRANCH,
  payload
})

export const deleteBranch = (payload) => ({
  type: DELETE_BRANCH,
  payload
})


// #######################################
// <------- Business info actions ------->
// #######################################
export const BUSINESS_INFO = 'BUSINESS_INFO'
export const EDIT_BUSINESS_INFO = 'EDIT_BUSINESS_INFO'

export const getBusinessInfo = (payload) => ({
  type: BUSINESS_INFO,
  payload
})

export const editBusinessInfo = (payload) => ({
  type: EDIT_BUSINESS_INFO,
  payload
})


// #######################################
// <--------- Caxhback actions ---------->
// #######################################
export const CASHBACK = 'CASHBACK'
export const ADD_CASHBACK = 'ADD_CASHBACK'
export const EDIT_CASHBACK = 'EDIT_CASHBACK'
export const DELETE_CASHBACK = 'DELETE_CASHBACK'

export const getCashback = (payload) => ({
  type: CASHBACK,
  payload
})

export const addCashback = (payload) => ({
  type: ADD_CASHBACK,
  payload
})

export const editCashback = (payload) => ({
  type: EDIT_CASHBACK,
  payload
})

export const deleteCashback = (payload) => ({
  type: DELETE_CASHBACK,
  payload
})


// #######################################
// <------ Settlement bank actions ------>
// #######################################
export const SETTLEMENT_BANK = 'SETTLEMENT_BANK'
export const ADD_SETTLEMENT_BANK = 'ADD_SETTLEMENT_BANK'
export const EDIT_SETTLEMENT_BANK = 'EDIT_SETTLEMENT_BANK'

export const getSettlementBank = (payload) => ({
  type: SETTLEMENT_BANK,
  payload
})


// #######################################
// <------------ User actions ----------->
// #######################################
export const USERS = 'USERS'
export const ADD_USER = 'ADD_USER'

export const getUsers = (payload) => ({
  type: USERS,
  payload
})

export const addUser = (payload) => ({
  type: ADD_USER,
  payload
})


// #######################################
// <------------ User actions ----------->
// #######################################
export const MERCHANT = 'MERCHANT'

export const getMerchant = (payload) => ({
  type: MERCHANT,
  payload
})

// #######################################
// <------------ Role actions ----------->
// #######################################
export const ROLES = 'ROLES'
export const ADD_ROLE = 'ADD_ROLE'
export const EDIT_ROLE = 'EDIT_ROLE'
export const DELETE_ROLE = 'DELETE_ROLE'

export const getRoles = (payload) => ({
  type: ROLES,
  payload
})

export const addRole = (payload) => ({
  type: ADD_ROLE,
  payload
})

export const editRole = (payload) => ({
  type: EDIT_ROLE,
  payload
})

export const deleteRole = (payload) => ({
  type: DELETE_ROLE,
  payload
})
